// Codekit -->

// Global -->
// @codekit-prepend "global/vars.js"

// Utilities -->
// @codekit-prepend "utilities/debounce.js"
// @codekit-prepend "utilities/load-in.js"
// @codekit-prepend "utilities/hero-images.js"
// @codekit-prepend "utilities/ajax.js"
// @codekit-prepend "utilities/scroll-to.js"
// @codekit-prepend "utilities/full-height.js"
// @codekit-prepend "utilities/hidden-nav.js"

// Components -->
// @codekit-prepend "components/menu.js"
// @codekit-prepend "components/logo-animation.js"
// @codekit-prepend "components/flickity.js"
// @codekit-prepend "components/map.js"
// @codekit-prepend "components/cookie-popup.js"
// @codekit-prepend "components/copy-link.js"
// @codekit-prepend "components/lightbox.js"
// @codekit-prepend "components/month-picker.js"

// Resize -->
// @codekit-append "global/document-ready.js"
// @codekit-append "global/resize.js"

//<- Codekit

//Funcitons start -->

//load in
loadIn();

//Menu
menu();

//Lightbox
initLightbox();


//Header
// window.addEventListener("scroll", debounce(headerReveal));

//Example function pullin
// if (typeof hero != "undefined" && hero != null) {
//     heroSize();
// }

if (typeof fullHeightEls != "undefined" && fullHeightEls != null) {
    makeFullHeight();
}

if (typeof cookiePopup != "undefined" && cookiePopup != null) {
    closeCookiePopup();
}

//<-- Funcitons end
